module.exports = __webpack_public_path__ + "static/media/grid_selected.d1b651c7.svg";